module.exports = __webpack_public_path__ + "images/Tencent_Music-090a36.png";